/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let employeeListUrl = root.employeeListUrl.link;
let newEmployeeUserApiUrl = root.newEmployeeUserApiUrl.link;
let updateEmployeeInfoUrl = root.updateEmployeeInfoUrl.link;
let employeeLeaveUrl = root.employeeLeaveUrl.link;
let adminEmployeeLeaveUrl = root.adminEmployeeLeaveUrl.link;
let emplooyeTaskApiUrl = root.emplooyeTaskApiUrl.link;
let interviewLogApiUrl = root.interviewLogApiUrl.link;
let activityTrackerApiUrl = root.activityTrackerApiUrl.link;
let managerLeaveFilterApiUrl = root.managerLeaveFilterApiUrl.link;
let stafListForManagerApiUrl = root.stafListForManagerApiUrl.link;
let adminAnnouncementApiUrl = root.adminAnnouncementApiUrl.link;
import Vue from 'vue'
export default {
  state: {
    employeeListState:{},
    employeeLeaveListState:{},
    getAdminOfEmployeeLeaveListState:{},
    getEmployeeTaskListState:{},
    interviewListState:{},
    interviewInfoByIdState:{},
    getEmployeeTaskInfoByIdState:{},
    getInterviewerListState:{}
  },
  mutations: {
    getInterviewerListMutation(state, value) {
      Vue.set(state, 'getInterviewerListState', value);
    },
    employeeListMutation(state, value) {
      Vue.set(state, 'employeeListState', value);
    },
    employeeLeaveListMutation(state, value) {
      Vue.set(state, 'employeeLeaveListState', value);
    },
    getAdminOfEmployeeLeaveListMutation(state, value) {
      Vue.set(state, 'getAdminOfEmployeeLeaveListState', value);
    },
    getEmployeeTaskListMutation(state, value) {
      Vue.set(state, 'getEmployeeTaskListState', value);
    },
    interviewListMutation(state, value) {
      Vue.set(state, 'interviewListState', value);
    },
    interviewInfoByIdMutation(state, value) {
      Vue.set(state, 'interviewInfoByIdState', value);
    },
    getEmployeeTaskInfoByIdMutation(state, value) {
      Vue.set(state, 'getEmployeeTaskInfoByIdState', value);
    },
  },
  actions: {
    // Admin Announcement Action
    adminAnnouncementAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(adminAnnouncementApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Staff List For Manager Action
    getStafListForManagerAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(stafListForManagerApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Manager Leave Filter Action
    getManagerLeaveFilterApiUrlFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(managerLeaveFilterApiUrl + '?user_id=' + payload.user_id + '&year=' + payload.year + '&month=' + payload.month).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Employee List Of Filter Action
    getActivityTrackerListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(activityTrackerApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Employee List Of Filter Action
    geEmployeeLisOfFiltertFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(employeeListUrl + '?user_type=' + payload.id).then(res => {
              // context.commit('employeeListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Employee Action
    geEmployeeListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(employeeListUrl, payload).then(res => {
              context.commit('employeeListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Employee Action
    getInterviewerListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(employeeListUrl, payload).then(res => {
              context.commit('getInterviewerListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Employee User Info
    createNewEmployeeFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(newEmployeeUserApiUrl,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // UpdateEmployee User Info
    updateEmployeeInfoFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(updateEmployeeInfoUrl + payload.data.id + '/', payload.data.data ).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Employee Reqest For Leave User Info
    employeeRequestForLeaveFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(employeeLeaveUrl,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Employee Leave List Action
    geEmployeeLeaveListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(employeeLeaveUrl + '?page_size=15', payload).then(res => {
              context.commit('employeeLeaveListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Admin Of Employee Leave List Action
    getAdminOfEmployeeLeaveListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(adminEmployeeLeaveUrl + '?page_size=15', payload).then(res => {
              context.commit('getAdminOfEmployeeLeaveListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Employee Leave List Action
    updateEmployeeLeaveInfoFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(employeeLeaveUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Emplooye Task Method
    createEmployeeTaskFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(emplooyeTaskApiUrl,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Emplooye Task Method
    getEmployeeTaskListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(emplooyeTaskApiUrl,payload).then(res => {
              context.commit('getEmployeeTaskListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Emplooye Task Info  By Id Method
    getEmployeeTaskInfoByIDFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(emplooyeTaskApiUrl + payload.id + '/').then(res => {
              context.commit('getEmployeeTaskInfoByIdMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Emplooye Task Method
    updateEmployeeTaskFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(emplooyeTaskApiUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Interview List Action
    getFilterInterviewListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(interviewLogApiUrl + '?' + payload.filter_key + '=True').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Interview List Action
    getInterviewListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(interviewLogApiUrl, payload).then(res => {
              context.commit('interviewListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Interview List Action
    createInterviewInfoFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(interviewLogApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Interview Info By ID Action
    getInterviewInfoByIDFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(interviewLogApiUrl + payload.id + '/').then(res => {
              context.commit('interviewInfoByIdMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Interview Info Action
    updateInterviewInfoByIDFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(interviewLogApiUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Search Employee Leave List Action
    searchAdminOfEmployeeLeaveListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(adminEmployeeLeaveUrl + '?search_term=' + payload.search_term).then(res => {
              context.commit('getAdminOfEmployeeLeaveListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    employeeListGetters: state => state.employeeListState,
    employeeLeaveListGetters: state => state.employeeLeaveListState,
    getAdminOfEmployeeLeaveListGetters: state => state.getAdminOfEmployeeLeaveListState,
    getEmployeeTaskListGetters: state => state.getEmployeeTaskListState,
    interviewListGetters: state => state.interviewListState,
    interviewInfoByIdGetters: state => state.interviewInfoByIdState,
    getEmployeeTaskInfoByIdGetters: state => state.getEmployeeTaskInfoByIdState,
    getInterviewerListGetters:state => state.getInterviewerListState
  }
}